import { useState } from 'react';
import API from '../api';
import { useNavigate } from 'react-router-dom';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    try {
      await API.post(`/forgot-password?email=${encodeURIComponent(email)}`);
      setSent(true);
    } catch {
      alert('Error sending reset email');
    }
  };

  return sent ? (
    <div style={{ textAlign: 'center', marginTop: '4rem' }}>
      <p style={{ color: '#7CFC00', fontSize: '1.2rem', marginBottom: '1rem' }}>
        Reset email sent if account exists.
      </p>
      <button
        onClick={() => navigate('/login')}
        style={{
          backgroundColor: '#001c3d',
          color: '#7CFC00',
          padding: '0.6rem 1.5rem',
          borderRadius: '8px',
          border: 'none',
          cursor: 'pointer',
          fontSize: '1rem',
          marginRight: '1rem'
        }}
      >
        Back to Login
      </button>
      <button
        onClick={() => navigate('/')}
        style={{
          backgroundColor: '#001c3d',
          color: '#7CFC00',
          padding: '0.6rem 1.5rem',
          borderRadius: '8px',
          border: 'none',
          cursor: 'pointer',
          fontSize: '1rem'
        }}
      >
        Main Page
      </button>
    </div>
  ) : (
    <form
      onSubmit={submit}
      style={{ maxWidth: '400px', margin: '4rem auto', padding: '2rem', textAlign: 'center' }}
    >
      <h2 style={{ marginBottom: '1rem' }}>Forgot Password</h2>
      <input
        placeholder="Email"
        onChange={e => setEmail(e.target.value)}
        required
        style={{
          width: '95%',
          padding: '0.8rem',
          marginBottom: '1rem',
          borderRadius: '6px',
          border: '1px solid #ccc'
        }}
      />
      <button
        type="submit"
        style={{
          width: '100%',
          backgroundColor: '#7CFC00',
          color: '#000',
          fontWeight: 'bold',
          padding: '0.8rem',
          borderRadius: '8px',
          border: 'none',
          cursor: 'pointer',
          fontSize: '1.1rem',
          marginBottom: '1rem'
        }}
      >
        Send Reset Link
      </button>
      <button
        type="button"
        onClick={() => navigate('/')}
        style={{
          backgroundColor: '#001c3d',
          color: '#7CFC00',
          padding: '0.6rem 1.5rem',
          borderRadius: '8px',
          border: 'none',
          cursor: 'pointer',
          fontSize: '1rem'
        }}
      >
        Main Page
      </button>
    </form>
  );
}
